export const publishingStats = [
  { value: 500, suffix: '+', label: 'Books Published', icon: 'ri-book-open-line' },
  { value: 200, suffix: '+', label: 'Happy Authors', icon: 'ri-team-line' },
  { value: 4, suffix: '+', label: 'Years Experience', icon: 'ri-calendar-check-line' },
  { value: 60, suffix: '+', label: 'Book Fair Events', icon: 'ri-global-line' },
];

export const testimonials = [
  {
    id: 1,
    quote: 'Working with Leavitt Peak Press was the best decision I made for my book. Their team guided me through every step — from editing to marketing — with professionalism and genuine care. My book reached audiences I never thought possible.',
    author: 'Sharon Downey',
    role: 'Author, "Diverse Love"',
    avatar: 'https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2026/04/Diverse-Love_pap-scaled.jpg',
  },
  {
    id: 2,
    quote: 'From the very first consultation to the final book launch, Leavitt Peak Press exceeded every expectation. They helped me navigate the complex publishing world with ease and made my dream a reality.',
    author: 'Diana Grippo',
    role: 'Author, "Bipolar Chronicles"',
    avatar: 'https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/71l8FukSQL._SL1500_-1280x1498-1.jpg',
  },
  {
    id: 3,
    quote: 'Leavitt Peak Press doesn\'t just publish books — they build author brands. Their marketing expertise and industry connections opened doors for me at major book fairs and helped establish my presence in the literary world.',
    author: 'Nina Lisicar',
    role: 'Author, "What Happened at Lake Tallulah?"',
    avatar: 'https://mlhdhysslvu0.i.optimole.com/w:333/h:500/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/8B08R7WGTNB.01._SCLZZZZZZZ_SX500_-1.jpg',
  },
];

export const publishingProcess = [
  {
    step: 1,
    title: 'Submit Your Manuscript',
    description: 'Share your manuscript with us through our simple submission process. Our editorial team reviews every submission with care and attention.',
    icon: 'ri-file-text-line',
  },
  {
    step: 2,
    title: 'Editorial Excellence',
    description: 'Our experienced editors work closely with you to refine your manuscript, ensuring your voice shines through while meeting professional publishing standards.',
    icon: 'ri-edit-line',
  },
  {
    step: 3,
    title: 'Design & Production',
    description: 'Your book gets a stunning cover design and professional interior layout. We handle formatting for both print and digital editions with meticulous care.',
    icon: 'ri-palette-line',
  },
  {
    step: 4,
    title: 'Global Distribution',
    description: 'Your book reaches readers worldwide through Amazon, major retailers, and our extensive distribution network. We make sure your work is available everywhere.',
    icon: 'ri-global-line',
  },
  {
    step: 5,
    title: 'Marketing & Promotion',
    description: 'We showcase your book at international book fairs, run targeted marketing campaigns, and help you build your author brand through strategic promotion.',
    icon: 'ri-megaphone-line',
  },
];

export const partnerStatementDo = [
  {
    title: 'We represent authors',
    description:
      'We act as a publishing and representation partner — handling production, positioning, and the practical work of getting your title in front of readers.',
    icon: 'ri-user-star-line',
  },
  {
    title: 'We open doors to global events',
    description:
      'International book fairs, trade shows, signings, and showcases are where we invest. Your book travels with us to places it could not reach alone.',
    icon: 'ri-global-line',
  },
  {
    title: 'We build visible exposure',
    description:
      'Booth presence, catalogue placement, retail listings, and author showcases — steady, deliberate visibility rather than one loud burst.',
    icon: 'ri-eye-line',
  },
  {
    title: 'We stay reachable',
    description:
      'A real team you can call, email, and ask hard questions of, for as long as your title is with us.',
    icon: 'ri-customer-service-2-line',
  },
];

export const partnerStatementDont = [
  {
    title: 'We do not guarantee bestseller status',
    description:
      'No one can promise a ranking, an award, or a sales number. Anyone who does is selling you a feeling, not a service.',
  },
  {
    title: 'We do not promise specific sales figures',
    description:
      'Reader response is not something a publisher controls. We control the work we put in — not the outcome of the market.',
  },
  {
    title: 'We do not claim overnight results',
    description:
      'Visibility compounds. Fairs, catalogues, and retail placements build slowly and honestly.',
  },
  {
    title: 'We do not invent credentials',
    description:
      'No fabricated accolades, no purchased badges, no language that implies more than the work we actually do.',
  },
];

export const partnerFaq = [
  {
    question: 'Does Leavitt Peak Press guarantee my book will become a bestseller?',
    answer:
      'No, and we will never tell you otherwise. Bestseller status depends on reader behaviour, retailer algorithms, and timing — none of which a publisher controls. What we control is the work: professional production, retail availability, catalogue placement, and being present at events where your book can actually be seen.',
  },
  {
    question: 'Can you promise a specific number of sales?',
    answer:
      'We cannot, and we would be wary of anyone who does. Sales figures belong to the market. What we can commit to is a defined scope of work, a timeline, and documented participation — so you always know what was delivered, whether or not the market responds the way we both hope.',
  },
  {
    question: 'What does "representation" actually mean here?',
    answer:
      'It means we stand between your book and the industry on your behalf. We handle production, prepare and present your title to retail and distribution channels, carry it into international book fairs and showcases, and speak for it in rooms you may never enter. Your name stays on the cover; the work of being seen is ours to do.',
  },
  {
    question: 'Why don\'t I see a long trail of negative reviews from your authors?',
    answer:
      'Because the feedback we publish comes from authors who genuinely worked with us — people who sat in the same meetings, saw the same booth, and lived the same process. We do not manufacture praise, and we do not publish second-hand remarks from people who never signed with us. A short record like that is not proof we are perfect; it is simply proof that our relationships are the only thing we will let speak for us.',
  },
  {
    question: 'So what can I actually hold you to?',
    answer:
      'Four things: a written scope agreed before work begins, a named portfolio manager as your single point of contact, honest timelines instead of optimistic ones, and real event participation you can verify — photographs, booth numbers, catalogues, and listings rather than vague claims of exposure.',
  },
  {
    question: 'What happens if something goes wrong or a deadline slips?',
    answer:
      'You tell your portfolio manager, and we tell you the truth about it — including when the delay is ours. We would rather deliver an honest correction than a polished excuse. If we cannot deliver something we promised, we will say so plainly and put a remedy in writing.',
  },
];

export const partnerCommitments = [
  {
    title: 'A written scope before we begin',
    description: 'Every service listed, every deliverable named, nothing implied in conversation only.',
    icon: 'ri-file-list-3-line',
  },
  {
    title: 'A named person, not a ticket number',
    description: 'One portfolio manager who knows your book and answers for it from start to finish.',
    icon: 'ri-user-voice-line',
  },
  {
    title: 'Honest timelines',
    description: 'Real production schedules, including the parts that take longer than authors expect.',
    icon: 'ri-time-line',
  },
  {
    title: 'Participation you can verify',
    description: 'Booth numbers, fair catalogues, and event photographs — not claims of exposure.',
    icon: 'ri-map-pin-2-line',
  },
];

export const partnerFeedbackQuote = {
  quote: 'Working with Leavitt Peak Press was the best decision I made for my book.',
  author: 'Sharon Downey',
  role: 'Author, "Diverse Love"',
  avatar:
    'https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2026/04/Diverse-Love_pap-scaled.jpg',
};